module.exports = __webpack_public_path__ + "static/media/image5.6f5ef90a.png";